import type { UserStatus } from "@sitescene/types";

import { BaseDocument } from "./common";
import { External } from "./common";

export declare enum KindeOrganizationPropKey {
	City = "kp_org_city",
	Postcode = "kp_org_postcode",
	StateRegion = "kp_org_state_region",
	StreetAddress = "kp_org_street_address",
	StreetAddress2 = "kp_org_street_address_2",
}

export enum UserNotificationType {
	EMAIL = "email",
	TEXT = "text",
}

export enum UserRole {
	ADMIN = "admin",
	EDITOR = "editor",
	USER = "user",
	VIEWER = "viewer",
}

export interface KindeEvent<T extends string, D> {
	data: D;
	event_id: string;
	event_timestamp: string;
	source: string;
	timestamp: string;
	type: T;
}
export interface KindeOrganization {
	code: string;
	external_id: string;
	handle: string;
	name: string;
	properties?: KindeOrganizationProp[];
}
export type KindeOrganizationEvent = KindeEvent<
	"organization.created" | "organization.deleted" | "organization.updated",
	{
		organization: KindeOrganization;
	}
>;
export interface KindeOrganizationProp {
	id: string;
	key: KindeOrganizationPropKey;
	value: string;
}
export interface KindeUser {
	email: string;
	first_name: null | string;
	id: string;
	is_password_reset_requested: boolean;
	is_suspended: boolean;
	last_name: null | string;
	organizations: KindeUserOrganization[];
	phone: null | string;
	username: null | string;
}
export type KindeUserEvent = KindeEvent<
	"user.created" | "user.deleted" | "user.updated",
	{
		user: KindeUser;
	}
>;
export interface KindeUserOrganization {
	code: string;
	permissions?: string[];
	roles: Array<{
		id: string;
		key: string;
	}>;
}
export interface User extends BaseDocument {
	email: string;
	external: External;
	firstName: string;
	isSuperUser: boolean;
	lastActive?: string;
	lastName: string;
	location?: string;
	name?: string;
	notificationTypes: UserNotificationType[];
	phone?: string;
	picture?: string;
	roles: UserRole[];
	status: UserStatus;
}
